<template>
<div class="app-wrapper">
  <top-bar></top-bar>
  <div id="main-container-home">
    <app-main></app-main>
    <footer-bar v-if="!$isPhone"></footer-bar>
  </div>
  <footer-bar-m v-if="$isPhone"></footer-bar-m>
</div>
</template>

<script>
import { AppMain, TopBar, FooterBar, FooterBarM } from './components'

export default {
  name: 'layout',
  components: {
    AppMain,
    TopBar,
    FooterBar,
    FooterBarM
  },
  methods: {
    resize () {
      let pWidth = this.$isPhone ? 1080 : 1920
      let pTop = this.$isPhone ? 160 : 84
      let pBottom = this.$isPhone ? 224 : 0
      let height = window.innerHeight
      let width = window.innerWidth
      let p = pWidth / width
      let con = document.getElementById('main-container-home')
      con.style.maxHeight = `${height * p - pTop - pBottom}px`
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.resize()
    })
    window.addEventListener('resize', () => {
      this.resize()
    })
  }
}
</script>

<style lang='less' scoped>
 @import '~@/styles/variables.less';
// @media screen and (min-width: 769px) {
  .app-wrapper {
  .clearfix {
    &:after {
      content: "";
      display: table;
      clear: both;
    }
  }
  position: relative;
  height: 100%;
  width: 1920px;
  #main-container-home {
    position: absolute;
    top: 84px;
    width: 1920px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
// }
// @media screen and (max-width: 768px) {
//   .app-wrapper {
//   .clearfix {
//     &:after {
//       content: "";
//       display: table;
//       clear: both;
//     }
//   }
//   height: 100%;
//   width: 1080px;
//   #main-container-home {
//     position: absolute;
//     top: 160px;
//     width: 1080px;
//     overflow-y: auto;
//     overflow-x: hidden;
//   }
// }
// }
</style>
